module.exports = __webpack_public_path__ + "static/media/image.61898201.svg";